import React, { useEffect, useState } from 'react'
import toast, { Toaster } from 'react-hot-toast'
import { useSearchParams } from 'react-router-dom'
import { ModuleWindow, ModuleWindowType } from '../../components/moduleWindow/ModuleWindow'
import { translations } from '../../configs/translations'
import { RaceTypes } from '../../enums/RaceTypes'
import { CaseData } from '../../models/Case'
import { CaseTypes } from '../../models/CaseType'
import { UserProfile } from '../../models/UserProfile'
import UserService from '../../services/UserService'
import { useStore } from '../../store/store'
import { Header } from '../main/header/Header'
import { BattlepassBundles } from './battlepassBundles/BattlepassBundles'
import { OpenCase } from './cases/OpenCase'
import { CaseShop } from './caseShop/CaseShop'
import './DonateShop.css'
import { DonateTo } from './donateToMoney/DonateTo'
import { InventoryShop } from './inventory/InventoryShop'
import { Subscriptions } from './subscriptions/Subscriptions'

export type DonatePages =
    'main'
    | 'money'
    | 'xp'
    | 'subscription'
    | 'battlepass'
    | 'cases'
    | 'cars'
    | 'openCase'
    | 'cursors'
    | 'preloaders'
    | 'podiums'
    | 'battlepassBundles'
    | 'inventory'

export const DonateShop = () => {
    const [isModuleWindowOpen, setIsModuleWindowOpen] = React.useState(false)
    const [moduleWindowText, setModuleWindowText] = React.useState('')
    const [moduleWindowTitle, setModuleWindowTitle] = React.useState('')
    const [moduleWindowType, setModuleWindowType] = React.useState<ModuleWindowType>('default')
    const [isAccepted, setIsAccepted] = React.useState(false)
    const [page, setPage] = React.useState<DonatePages>('money')
    const [updateProfile, setUpdateProfile] = React.useState(false)
    const [profile, setProfile] = useState<UserProfile | null>(JSON.parse(localStorage.getItem('profile') || 'null'))


    const language = useStore(state => state.language) as keyof typeof translations
    const t = translations[language]

    const [searchParams] = useSearchParams()
    const pageParam = searchParams.get('page')

    useEffect(() => {
        console.log(pageParam)
        if (pageParam) {
            setPage(pageParam as DonatePages)
        }
    }, [pageParam])

    useEffect(() => {
        if (isAccepted) {
            setIsAccepted(false)
        }
    }, [isAccepted])

    const moneyPage = (
        <DonateTo
            setModuleWindowOpen={setIsModuleWindowOpen}
            setModuleWindowText={setModuleWindowText}
            setModuleWindowTitle={setModuleWindowTitle}
            isAccepted={isAccepted}
            dpAmount={profile?.donatePoints || 0}
            toItemAmount={profile?.balance || 0}
            page={page}
            setProfile={setProfile}
        />
    )

    const xpPage = (
        <DonateTo
            setModuleWindowOpen={setIsModuleWindowOpen}
            setModuleWindowText={setModuleWindowText}
            setModuleWindowTitle={setModuleWindowTitle}
            isAccepted={isAccepted}
            dpAmount={profile?.donatePoints || 0}
            toItemAmount={profile?.experience || 0}
            page={page}
            setProfile={setProfile}
        />
    )

    const subscriptionsPage = (
        <Subscriptions
            setModuleWindowOpen={setIsModuleWindowOpen}
            setModuleWindowText={setModuleWindowText}
            setModuleWindowTitle={setModuleWindowTitle}
            isAccepted={isAccepted}
            setProfile={setProfile}
        />
    )

    const [caseType, setCaseType] = useState<CaseTypes>('NONE')

    const openCasePage = (
        <OpenCase caseType={caseType} setProfile={setProfile} />
    )

    const audio = new Audio('./sounds/buy.mp3')
    const getOnCaseBuyFunc = (type: string): () => void => {
        return async () => {
            await UserService.buyCase(type)
                .then(() => {
                    audio.play()
                    setProfile(null)
                })
                .catch((error) => {
                    toast.error(
                        error && error.response && error.response.data && t[error.response.data as keyof typeof t]
                            ? t[error.response.data as keyof typeof t]
                            : t.error_unknown,
                        { className: 'notification-error' }
                    )
                })
        }
    }

    const cases: CaseData[] = [
        {
            id: 1,
            name: 'Case Phantom',
            type: 'CAR_PHANTOM',
            skinPath: './cases/phantom.png',
            price: 200,
            onBuy: (e) => {
                getOnCaseBuyFunc('CAR_PHANTOM')()
                e.preventDefault()
                e.stopPropagation()
            },
            onCardClick: () => {
                setCaseType('CAR_PHANTOM')
                setPage('openCase')
            }
        },
    ]
    const casesPage = (
        <CaseShop cases={cases} />
    )

    const inventoryPage = (
        <InventoryShop />
    )

    const [modulWindowInputValue, setModulWindowInputValue] = useState<string | number | null>(10)
    const [modulWindowInputPrice, setModulWindowInputPrice] = useState<number>(0)
    const battlepassBundlesPage = (
        <>
            {profile ?
                <BattlepassBundles
                    setModuleWindowTitle={setModuleWindowTitle}
                    setModuleWindowText={setModuleWindowText}
                    setModuleWindowOpen={setIsModuleWindowOpen}
                    setModuleWindowType={setModuleWindowType}
                    isAccepted={isAccepted}
                    setInputValue={setModulWindowInputValue}
                    inputValue={modulWindowInputValue as number}
                    setInputPrice={setModulWindowInputPrice}
                    inputPrice={modulWindowInputPrice}
                    userProfile={profile}
                    setProfile={setProfile}
                />
                : null
            }
        </>
    )

    const getPage = () => {
        switch (page) {
            case 'money':
                return moneyPage
            case 'xp':
                return xpPage
            case 'subscription':
                return subscriptionsPage
            case 'cases':
                return casesPage
            case 'openCase':
                return openCasePage
            case 'cursors':
                return casesPage
            case 'preloaders':
                return casesPage
            case 'podiums':
                return casesPage
            case 'battlepassBundles':
                return battlepassBundlesPage
            case 'inventory':
                return inventoryPage
            default:
                return moneyPage
        }
    }

    useEffect(() => {
        console.log('new profile', profile)
    }, [profile])

    return (
        <>
            {
                <>
                    {isModuleWindowOpen && (
                        <ModuleWindow
                            title={moduleWindowTitle}
                            text={moduleWindowText}
                            onYes={() => setIsAccepted(true)}
                            onNo={() => setIsModuleWindowOpen(false)}
                            type={moduleWindowType}
                            inputValue={modulWindowInputValue}
                            inputPrice={modulWindowInputPrice}
                            setInputValue={setModulWindowInputValue}
                        />
                    )}
                    <Header
                        profile={profile}
                        setProfile={setProfile}
                        selectedMode={RaceTypes.RANKED}
                        selectedVehicle={null}
                        title={t.donate_shop}
                    />
                    <div className='donate-shop-wrapper'>
                        <div className="donate-shop">
                            <div className="donate-shop-header-container">
                                <div className="dp-balance-container" style={{ visibility: 'hidden' }}>
                                    <div className='dp-balance-icon'>
                                        <img src="./icons/32px/dp.png" alt="dp" />
                                    </div>
                                    <p>{profile?.donatePoints || 0}</p>
                                </div>
                            </div>
                            <div className="donate-shop-content-wrapper">
                                <div className='donate-shop-burger-menu'>
                                    <div
                                        onClick={() => setPage('main')}
                                        className={`${page === 'main' ? 'donate-shop-burger-menu-item active' : 'donate-shop-burger-menu-item'}`}
                                    >
                                        <p>{t.discounts}</p>
                                    </div>
                                    <div
                                        onClick={() => setPage('money')}
                                        className={`${page === 'money' ? 'donate-shop-burger-menu-item active' : 'donate-shop-burger-menu-item'}`}
                                    >
                                        <p>{t.money}</p>
                                    </div>
                                    <div
                                        onClick={() => setPage('xp')}
                                        className={`${page === 'xp' ? 'donate-shop-burger-menu-item active' : 'donate-shop-burger-menu-item'}`}
                                    >
                                        <p>{t.xp}</p>
                                    </div>
                                    <div
                                        onClick={() => setPage('subscription')}
                                        className={`${page === 'subscription' ? 'donate-shop-burger-menu-item active' : 'donate-shop-burger-menu-item'}`}
                                    >
                                        <p>{t.subscription}</p>
                                    </div>
                                    <div
                                        onClick={() => setPage('battlepassBundles')}
                                        className={`${page === 'battlepassBundles' ? 'donate-shop-burger-menu-item active' : 'donate-shop-burger-menu-item'}`}
                                    >
                                        <p>{t.battlepass}</p>
                                    </div>
                                    <div
                                        onClick={() => setPage('cases')}
                                        className={`${page === 'cases' ? 'donate-shop-burger-menu-item active' : 'donate-shop-burger-menu-item'}`}
                                    >
                                        <p>{t.cases}</p>
                                    </div>
                                    <div
                                        onClick={() => setPage('cars')}
                                        className={`${page === 'cars' ? 'donate-shop-burger-menu-item active' : 'donate-shop-burger-menu-item'}`}
                                    >
                                        <p>{t.cars}</p>
                                    </div>
                                    <div
                                        onClick={() => setPage('cursors')}
                                        className={`${page === 'cursors' ? 'donate-shop-burger-menu-item active' : 'donate-shop-burger-menu-item'}`}
                                    >
                                        <p>{t.cursors}</p>
                                    </div>
                                    <div
                                        onClick={() => setPage('preloaders')}
                                        className={`${page === 'preloaders' ? 'donate-shop-burger-menu-item active' : 'donate-shop-burger-menu-item'}`}
                                    >
                                        <p>{t.preloaders}</p>
                                    </div>
                                    <div
                                        onClick={() => setPage('podiums')}
                                        className={`${page === 'podiums' ? 'donate-shop-burger-menu-item active' : 'donate-shop-burger-menu-item'}`}
                                    >
                                        <p>{t.podiums}</p>
                                    </div>
                                    <div
                                        onClick={() => setPage('inventory')}
                                        className={`${page === 'inventory' ? 'donate-shop-burger-menu-item active' : 'donate-shop-burger-menu-item'}`}
                                    >
                                        <p style={{ color: '#707070', fontWeight: 400 }}>{t.inventory}</p>
                                    </div>
                                </div>

                                <div className='donate-shop-content'>
                                    {getPage()}
                                </div>
                            </div>
                        </div>
                    </div>
                    <Toaster
                        position="bottom-center"
                        toastOptions={{
                            duration: 2000,
                        }}
                    />
                </>}
        </>
    )
}
